import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import config from 'config';

import './partnership-widget.css';

export class PartnershipWidgetPage extends Component {
  constructor(...args) {
    super(...args);
    this.focusHandler = this.onFocus.bind(this);
  }

  componentDidMount() {
    if (this.textarea) {
      this.textarea.select();
    }
  }

  onFocus(evt) {
    evt.target.select();
  }

  generateIframeSrc() {
    const { params: { code, lang } } = this.props;
    return `${config.appProtocol}://${config.appDomain}/${lang}/embed/${code}/`;
  }

  generateValue() {
    const url = this.generateIframeSrc();

    return `<iframe width="350" height="560" frameBorder="0" src="${url}"></iframe>`;
  }

  render() {
    const { t } = this.props;

    return (
      <div className="partnership-widget-container">
        <Grid>
          <Row>
            <Col lg={7} md={12} className="code-section">
              <h1>{t('Generate partnership widget')}</h1>

              <h4>{t('Code to paste')}</h4>

              <textarea
                ref={el => this.textarea = el}
                value={this.generateValue()}
                readOnly
                onClick={this.focusHandler}
              />
            </Col>

            <Col lg={5} md={12} className="iframe-section">
              <h3>{t('Preview')}</h3>

              <iframe title="partners-widget" width="350" height="560" frameBorder="0" src={this.generateIframeSrc()} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default translate(['translation'])(PartnershipWidgetPage);



// WEBPACK FOOTER //
// ./src/components/Partnership/index.js